import styled from 'styled-components';

export const HttpsText = styled.p`
  font-size: 16px;
  line-height: 150%;
  color: ${props => props.theme.interface5};
`;
